// removed by extract-text-webpack-plugin
module.exports = {"selected":"app-pages-Ingredient-Category-List-__List___u8T-X","wrapper":"app-pages-Ingredient-Category-List-__List___KY10i","table-header":"app-pages-Ingredient-Category-List-__List___3oHUz","table-content-wrapper":"app-pages-Ingredient-Category-List-__List___3Bg5B","table-content":"app-pages-Ingredient-Category-List-__List___DVJZ0"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Ingredient/Category/List/List.css
// module id = 2353
// module chunks = 0